import {createContext} from "react";
import {createContextualCan} from "@casl/react";

import {AppAbility} from "./abilities";

export const AbilityContext = createContext<AppAbility>(undefined!);
export const AbilityProvider = AbilityContext.Provider;
export const Can = createContextualCan(AbilityContext.Consumer);
